import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiIsFollowingUserVariables = Types.Exact<{
  accountAddress: Types.Scalars['String'];
}>;


export type ApiIsFollowingUser = { isFollowingUser: boolean };



export const ApiIsFollowingUserDocument = /*#__PURE__*/ `
    query IsFollowingUser($accountAddress: String!) {
  isFollowingUser(accountAddress: $accountAddress)
}
    `;

export const useIsFollowingUser = <
      TData = ApiIsFollowingUser,
      TError = ClientError
    >(
      variables: ApiIsFollowingUserVariables,
      options?: Omit<UseQueryOptions<ApiIsFollowingUser, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiIsFollowingUser, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiIsFollowingUser, TError, TData>(
      {
    queryKey: ['IsFollowingUser', variables],
    queryFn: apiFetcher<ApiIsFollowingUser, ApiIsFollowingUserVariables>(ApiIsFollowingUserDocument, variables),
    ...options
  }
    )};

useIsFollowingUser.getKey = (variables: ApiIsFollowingUserVariables) => ['IsFollowingUser', variables];

export const useInfiniteIsFollowingUser = <
      TData = InfiniteData<ApiIsFollowingUser>,
      TError = ClientError
    >(
      variables: ApiIsFollowingUserVariables,
      options: Omit<UseInfiniteQueryOptions<ApiIsFollowingUser, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiIsFollowingUser, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiIsFollowingUser, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IsFollowingUser.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiIsFollowingUser, ApiIsFollowingUserVariables>(ApiIsFollowingUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteIsFollowingUser.getKey = (variables: ApiIsFollowingUserVariables) => ['IsFollowingUser.infinite', variables];


useIsFollowingUser.fetcher = (variables: ApiIsFollowingUserVariables, options?: RequestInit['headers']) => apiFetcher<ApiIsFollowingUser, ApiIsFollowingUserVariables>(ApiIsFollowingUserDocument, variables, options);
